import { render, staticRenderFns } from "./hlw.vue?vue&type=template&id=b1f00a84&scoped=true&"
var script = {}
import style0 from "./hlw.vue?vue&type=style&index=0&id=b1f00a84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f00a84",
  null
  
)

export default component.exports